module.exports = __webpack_public_path__ + "static/media/country_gl.8d7218ee.webp";